// extracted by mini-css-extract-plugin
module.exports = {"content":"dp-CIqeT5t5","title":"dp-wflsZtCf","desc":"dp-5qLXk0sw","btn":"dp-K1LwpPas"};